import { sanityOriginClient } from './client';
import { PREDICTED_LINEUPS_CARD_PROJECTION } from './listings';
import type { SanityPredictedLineupsCard } from './listings';
import {
  predictedLineupsPageDraftQuery,
  predictedLineupsPageQuery
} from './queries';
import type { SanityPredictedLineupsPage } from './types';

/** Must match PREDICTED_LINEUPS_SINGLETON_ID in sanity/schemaTypes/predictedLineupsPage.ts. */
export const PREDICTED_LINEUPS_SINGLETON_ID = 'predictedLineupsPage';

// Replaced the WordPress article at /premier-league-predicted-lineups, which
// next.config.js 301s here along with the old /predicted-lineups-beta route.
export const PREDICTED_LINEUPS_PATH = '/predicted-lineups';

export const getPredictedLineupsPage =
  async (): Promise<SanityPredictedLineupsPage | null> => {
    const page = await sanityOriginClient.fetch<SanityPredictedLineupsPage | null>(
      predictedLineupsPageQuery,
      { id: PREDICTED_LINEUPS_SINGLETON_ID }
    );
    return page ?? null;
  };

export const predictedLineupsCardQuery = `*[_id == $id][0] ${PREDICTED_LINEUPS_CARD_PROJECTION}`;

/**
 * The page as a listing card, for the homepage's team news slot. Null when it
 * is unpublished or Sanity fails, so the homepage falls back to the newest
 * team news piece instead of failing its regeneration.
 */
export const getPredictedLineupsCard =
  async (): Promise<SanityPredictedLineupsCard | null> => {
    try {
      const card =
        await sanityOriginClient.fetch<SanityPredictedLineupsCard | null>(
          predictedLineupsCardQuery,
          { id: PREDICTED_LINEUPS_SINGLETON_ID }
        );
      return card ?? null;
    } catch (error) {
      console.error('[predictedLineups] failed to fetch the card', error);
      return null;
    }
  };

/**
 * Draft-or-published read, premium club sections included, for the editor
 * preview route only.
 */
export const getPredictedLineupsPageDraft =
  async (): Promise<SanityPredictedLineupsPage | null> => {
    const page = await sanityOriginClient
      .withConfig({ perspective: 'drafts' })
      .fetch<SanityPredictedLineupsPage | null>(predictedLineupsPageDraftQuery, {
        id: PREDICTED_LINEUPS_SINGLETON_ID
      });
    return page ?? null;
  };
